// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Security View Model
 */
!(function () {
  var observe = require('mobx').observe;
  var fetcher = require('fetchers/Izenda.AdvancedSettingDataFetcher');
  var connectionStringDataFetcher = require('fetchers/Izenda.ConnectionStringDataFetcher');
  var uiState = require('logic/Izenda.UiState');
  var AppGlobal = require('Izenda.AppGlobal');

  var securityConstants = require('./data/Izenda.SecurityConstants');
  var SecurityModel = require('./models/Izenda.Security');

  function SecurityStore() {
    this.model = new SecurityModel();
  }

  /**
   * init for the first time componentWillMount, link between UISTate and store
   */
  SecurityStore.prototype.init = function () {
    this.observeTenantId();
    uiState.setCheckDirtyFunction(function(){return this.model.isDirty}.bind(this));

    return this.getInitial();
  }

  /**
   * Observe tenantID on setting level
   */
  SecurityStore.prototype.observeTenantId = function () {
    this.disposeSecurity = observe(uiState, 'tenantId', function () {
      if (uiState.silentUpdate) return;
      this.getInitial();
    }.bind(this));
  };

  /**
   * Load Initial Data
   */
  SecurityStore.prototype.getInitial = function () {
    this.model.resetErrorMessage();

    return fetcher.getTenantSecurity(uiState.getTenantId())
      .then(this.model.readSecuritySetting.bind(this.model));
  };

  /**
   * unlink between UIState and store
   */
  SecurityStore.prototype.destroy = function () {
    uiState.resetCheckDirtyFunction();
    this.disposeSecurity();
  };

  /**
   * Save tenant security
   */
  SecurityStore.prototype.saveTenantSecurity = function () {
    var data = this.model.buildSaveData(uiState.getTenantId());

    return fetcher.saveTenantSecurity(data)
                  .then(this.model.showAlertMessage.bind(this.model))
                  .then(this.model.resetDirty)
                  .then(AppGlobal.setSecurity.bind(AppGlobal, data)); // update AppGlobal when have changes
  };

  /**
   * Load Security Setting
   */
  SecurityStore.prototype.loadSecurity = function () {
    return fetcher.getTenantSecurity(uiState.getTenantId());
  };

  /**
   * Load connections 
   */
  SecurityStore.prototype.getConnectionDetailInfo = function () {
    return connectionStringDataFetcher.getConnectionDetailInfo(uiState.getTenantId(), false, {defaultChecked: false});
  };

  /**
   * Load connections by query sources
   */
  SecurityStore.prototype.getConnectionDetailInfoByQuerySoures = function (request) {
    return connectionStringDataFetcher.getConnectionDetailInfoByQuerySoures(request);
  };

  /**
   * Get Bundle
   * @returns {object} bundle
   */
  SecurityStore.prototype.getBundle = function () {
    return securityConstants.BUNDLE;
  };

  module.exports = SecurityStore;
}());



// WEBPACK FOOTER //
// ./ui/logic/Izenda.SecurityStore.js